module.exports = __webpack_public_path__ + "static/media/quick-apply-loan@3x.65440bd0.png";